/**
 * Application routes configuration
 * Централизованное управление маршрутами
 */

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',

  CASHIER: '/dashboard/cashier-workplace',

  REPORTS: {
    ROOT: '/dashboard/reports',
    PRODUCT_RATING: '/dashboard/reports/product-rating',
    AVERAGE_CHECK: '/dashboard/reports/average-check',
    SALES_ANALYSIS: '/dashboard/reports/sales-analysis',
    STOCK_BALANCE: '/dashboard/reports/stock-balance',
    CASH_BALANCE: '/dashboard/reports/cash-balance',
  },

  OPERATIONS: {
    ROOT: '/dashboard/operations',
    RECEIPT: '/dashboard/operations/receipt',
    SALE: '/dashboard/operations/sale',
    WRITE_OFF: '/dashboard/operations/write-off',
    RETURN: '/dashboard/operations/return-from-customer',
  },

  REFERENCES: {
    ROOT: '/dashboard/references',
    BANKS: '/dashboard/references/banks',
    BANK_ACCOUNTS: '/dashboard/references/bank-accounts',
    WAREHOUSES: '/dashboard/references/warehouses',
    PRODUCT_CATEGORIES: '/dashboard/references/product-categories',
    CONTRACTORS: '/dashboard/references/contractors',
    CONTRACTS: '/dashboard/references/contracts',
    PRODUCTS: '/dashboard/references/products',
    COUNTRIES: '/dashboard/references/countries',
    GEKD_CODES: '/dashboard/references/gekd-codes',
    TNVED_CODES: '/dashboard/references/tnved-codes',
    UNITS: '/dashboard/references/units',
  },
} as const;

// Маппинг старых ID на новые роуты (для обратной совместимости)
export const MENU_ID_TO_ROUTE: Record<string, string> = {
  'cashier-workplace': ROUTES.CASHIER,
  'product-rating': ROUTES.REPORTS.PRODUCT_RATING,
  'average-check': ROUTES.REPORTS.AVERAGE_CHECK,
  'sales-analysis': ROUTES.REPORTS.SALES_ANALYSIS,
  'stock-balance': ROUTES.REPORTS.STOCK_BALANCE,
  'cash-balance': ROUTES.REPORTS.CASH_BALANCE,
  'receipt': ROUTES.OPERATIONS.RECEIPT,
  'sale': ROUTES.OPERATIONS.SALE,
  'write-off': ROUTES.OPERATIONS.WRITE_OFF,
  'return-from-customer': ROUTES.OPERATIONS.RETURN,
  'banks': ROUTES.REFERENCES.BANKS,
  'bank-accounts': ROUTES.REFERENCES.BANK_ACCOUNTS,
  'warehouses': ROUTES.REFERENCES.WAREHOUSES,
  'product-categories': ROUTES.REFERENCES.PRODUCT_CATEGORIES,
  'contractors': ROUTES.REFERENCES.CONTRACTORS,
  'contracts': ROUTES.REFERENCES.CONTRACTS,
  'products': ROUTES.REFERENCES.PRODUCTS,
  'countries': ROUTES.REFERENCES.COUNTRIES,
  'gekd-codes': ROUTES.REFERENCES.GEKD_CODES,
  'tnved-codes': ROUTES.REFERENCES.TNVED_CODES,
  'units': ROUTES.REFERENCES.UNITS,
};
